import * as angular from "angular";
import {IController} from "angular";

export class auctionOfferDriverScoringCtrl implements IController {

  offer: any;

  /* @ngInject */
  constructor(private $mdDialog) {
  }

  cancel() {
    this.$mdDialog.cancel();
  }

}

angular
  .module('bringoz.admin.auctions')
  .component('auctionOfferDriverScoring', {
    bindings: {
      offer : '='
    },
    template: require('./auction-offer-driver-scoring.html').default,
    controller: auctionOfferDriverScoringCtrl
  });

